import { render, staticRenderFns } from "./MoAboutPage.vue?vue&type=template&id=1dcd3108&scoped=true&"
import script from "./MoAboutPage.vue?vue&type=script&lang=js&"
export * from "./MoAboutPage.vue?vue&type=script&lang=js&"
import style0 from "./MoAboutPage.vue?vue&type=style&index=0&id=1dcd3108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd3108",
  null
  
)

export default component.exports